<template>
  <div class="pre-bids-list tab-table p-2">
    <PreBidsTable/>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import PreBidsTable from "@/modules/pre-bids/PreBidsTable.vue";

const {mapActions: preBidsMapActions} = createNamespacedHelpers('preBids');
const {mapState} = createNamespacedHelpers('reservations');

export default {
  name: "PreBidsView",
  components: {PreBidsTable,},
  computed: {
    ...mapState({
      sale: state => state.view.currentReservation.auction
    }),
  },
  methods: {
    ...preBidsMapActions(['updateTableSource'])
  },
  async beforeMount() {
    if (this.sale) {
      await this.updateTableSource({
        source: 'sale',
        extraFilters: {auction_uuid: this.sale.uuid},
        sale: this.sale
      });
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
